/** Port of gds-monitoring-data.ts (Vue) — Amadeus enrichment view types. */

export interface GdsFlightInfoCustomFields {
  aircraftOwner?: string;
  cockpitCrew?: string;
  cabinCrew?: string;
  memberOf?: string;
  departureTerminal?: string;
  arrivalTerminal?: string;
  operatedBy?: string;
}

export interface GdsFlightInfo {
  marketingCarrier?: string;
  operatingCarrier?: string | null;
  flightNumber?: string;
  cancelled?: boolean;
  customFields?: GdsFlightInfoCustomFields;
}

export interface GdsMonitoringData {
  flightInfo?: GdsFlightInfo;
  raw?: unknown;
}

export function parseGdsMonitoringData(value: unknown): GdsMonitoringData | null {
  if (!value || typeof value !== "object") {
    return null;
  }
  return value as GdsMonitoringData;
}

/** Human-readable labels for each Amadeus custom field, in display order. */
export const GDS_CUSTOM_FIELD_LABELS: {
  key: keyof GdsFlightInfoCustomFields;
  label: string;
}[] = [
  { key: "operatedBy", label: "Opéré par" },
  { key: "aircraftOwner", label: "Propriétaire de l'appareil" },
  { key: "cockpitCrew", label: "Équipage technique" },
  { key: "cabinCrew", label: "Personnel de cabine" },
  { key: "memberOf", label: "Alliance" },
  { key: "departureTerminal", label: "Terminal de départ" },
  { key: "arrivalTerminal", label: "Terminal d'arrivée" },
];
